import { createContext, useContext, useRef, useState } from "react";
import Message from "../Components/Notification/Message"
import { authContext } from "./authContext";
import AddTenant from "../Components/AddTenant";
import ImageTaker from "../Components/ImageTaker";
import AddUser from "../Components/AddUser";
import Confirm from "../Components/Confirm";

export const appContext = createContext()

export default function AppContext({ children }){
    const [showSidebar, setShowSidebar] = useState(false)
    const {token} = useContext(authContext)
    const messageRef = useRef()
    const showMessage = (msg, error) => {
        messageRef.current?.((error ? '❗️ ' : '✅ ' ) + msg)
    }
    const [showAddTenant, setShowAddTenant] = useState({})
    const toggleATenant = (item) => setShowAddTenant(s => ({visible: !s.visible, data: item}))

    const [showAddUser, setShowAddUser] = useState({})
    const toggleAUser = (item) => setShowAddUser(s => ({...s, visible: !s.visible, data: item}))

    const [imageControl, setImageControl] = useState({})
    const [confirm, setConfirm] = useState({})

    function isMobileDevice() {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
    }

    return (
        <appContext.Provider value={{ 
            showSidebar, setShowSidebar, showMessage, isMobileDevice,
            showAddTenant, toggleATenant, imageControl, setImageControl,
            showAddUser, toggleAUser, setShowAddUser, confirm, setConfirm
         }}>
            {children}
            <Message
                children={(add) => {
                messageRef.current = add
                }}
            />
            {token && (
                <>
                    <AddTenant />
                    <AddUser />
                    <Confirm />
                    {imageControl.visible && <ImageTaker />}
                </>
            )}
        </appContext.Provider>
    )
}